/**
 * Same as claim types in Entity/Claim.php
 * NB: Keep in sync
 */
export enum ClaimType {
  MONETARY = 0,
  NONMONETARY = 1,
  PERIODICAL = 2,
}
